var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Subscription.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3ee27e62!../../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Subscription.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/backoffice/controllers/Subscription.vue
// module id = 2087
// module chunks = 1